module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/result_unsuccess-ff18b6c09b5603bebd5e3a116a57f0e8.svg";